import React from "react";
import Preloader from "./Preloader";

const Table = ({ props }) => {
  const titles = [
    "Ugur",
    "Uçuş belgisi",
    "Uçuş güni",
    "Gidiş wagty",
    "Geliş wagty",
  ];

  const convertTimeFormat = (timeStr) => {
    if (!timeStr) return "";
    const [hours, minutes] = timeStr.split(":");
    return `${hours}:${minutes}`;
  };

  if (!props) {
    return <Preloader />;
  }

  return (
    <div className="mx-auto my-9 space-y-8">
      {props.map((section, sectionIndex) => (
        <div key={`${section.title}-${sectionIndex}`}>
          <p className="mb-4 text-center text-black font-bold text-[20px]">
            {section.title}
          </p>

          <div className="grid grid-cols-5 text-center bg-[#e6e6e6] items-center justify-center">
            {titles.map((title) => (
              <p key={title} className="text-black font-bold py-3">
                {title}
              </p>
            ))}
          </div>

          <div className="grid grid-cols-5 text-center items-center justify-center">
            {(section.results || []).map((item, i) => {
              const bgClass = i % 2 !== 0 ? "bg-[#F1F1F1]" : "bg-white";

              return (
                <React.Fragment key={item.id || `${item.flight_number}-${i}`}>
                  <p className={`text-black py-3 ${bgClass}`}>
                    {item.origin_city} - {item.destination_city}
                  </p>

                  <p className={`text-black py-3 ${bgClass}`}>
                    {item.flight_number}
                  </p>

                  <p className={`text-black py-3 ${bgClass}`}>
                    {(item.departure_days || []).join(", ")}
                  </p>

                  <p className={`text-black py-3 ${bgClass}`}>
                    {convertTimeFormat(item.departure_time)}
                  </p>

                  <p className={`text-black py-3 ${bgClass}`}>
                    {convertTimeFormat(item.arrival_time)}
                  </p>
                </React.Fragment>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Table;
